<template>
  <div class="wrapper" id="chatContainer" v-if="is_loading">
    <div class="page1" v-if="!is_start">
      <div class="rex role1" v-if="initData.role_name === '小香猪'"></div>
      <div class="rex role2" v-if="initData.role_name === '小灵猴'"></div>
      <div class="rex role3" v-if="initData.role_name === '小白龙'"></div>

      <div class="role-play"></div>
      <div class="bgline"></div>
    </div>
    <div class="page2" v-else>
      <div class="story-info" @click="nextEvent()" v-if="!is_result">
        <div class="heades">
          <!-- 1用户信息 -->
          <div class="user">
            <div class="pics role1" v-if="initData.role_name === '小香猪'"></div>
            <div class="pics role2" v-if="initData.role_name === '小灵猴'"></div>
            <div class="pics role3" v-if="initData.role_name === '小白龙'"></div>
            <!-- <img v-if="initData.role_name === '小灵猴'" src="./images/wukong.png" />
              <img  src="./images/zhubajie.png" />
              <img v-if="initData.role_name === '小白龙'" src="./images/xibailong.png" /> -->

            <div class="taems">
              <div class="name">
                {{ initData.role_name }}
              </div>
              <div class="progress">
                <p class="tls"></p>
                <div class="box"><span class="val" :style="`width:${progressVal}%`"></span></div>
              </div>
            </div>
          </div>
          <!-- 2 取精团队-->
          <div class="team-box">
            <p class="tls"></p>
            <div class="item">
              <span v-for="(item, index) in initData.team_mate" :key="index">{{ item }}</span>
            </div>
          </div>
          <!-- 年轮 -->
          <div class="team-year">
            <!-- <span class="nl5"></span>
            <span class="nl8"></span> -->
            <span :class="'nl' + item" v-for="(item, index) in yearlist" :key="index"></span>
          </div>
        </div>
        <div class="text-body" :class="miniHeight ? 'text-body-min text-body' : 'text-body'">
          <div class="textval" id="textval" ref="textval">
            <p v-for="(item, index) in stagelist" :key="index" v-html="item"></p>
          </div>
        </div>
        <div class="next-btn"></div>
      </div>

      <div class="result story-info" v-else>
        <div class="heades">
          <!-- 1用户信息 -->
          <div class="user">
            <div class="pics role1" v-if="initData.role_name === '小香猪'"></div>
            <div class="pics role2" v-if="initData.role_name === '小灵猴'"></div>
            <div class="pics role3" v-if="initData.role_name === '小白龙'"></div>
            <!-- <div class="pics">
              <img src="./images/enterdesk.jpeg" />
            </div> -->
            <div class="taems">
              <div class="name">
                {{ initData.role_name }}
              </div>
            </div>
          </div>
        </div>
        <!-- story_ending.png -->
        <div class="story-ending"></div>
        <div class="story-tip-text">
          你花了<span>{{ yearnum === '00' ? 0 : yearnum }}年</span>时间，最终<span
            v-if="resultInfo.tp === 1"
            style="color:#7be6f6"
            >取经成功</span
          ><span v-else>取经失败</span>
        </div>
        <div class="text-body">
          <div class="result-end">
            <div class="endpic">
              <img :src="end_picture" />
            </div>
            <div v-html="resultInfo.text"></div>
            <div class="sharebtn">
              <span @click="onShareBtn(1)"></span>
            </div>
            <div class="playonce">
              <span @click="playingOnce()"></span>
            </div>
            <div class="linkbtn">
              <div><a href="https://mp.weixin.qq.com/s/5HKd-IILrT1Kg1lBkDVXtQ" target="_blank"></a></div>
              <div id="launch-btn">
                <wx-open-launch-weapp
                  id="launch-btn"
                  username="gh_c5aa58b251c1"
                  path="pages/index/index?q=hhxxl-mnq"
                  @error="handleErrorFn()"
                  @launch="handleLaunchFn()"
                >
                  <script type="text/wxtag-template">
                                <style>.btn{ width:246px;
                    height:90px;display:inline-block; opacity:0}</style>
                              <button class="btn">打开小程序</button>
                  </script>
                </wx-open-launch-weapp>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 没有次数提示 -->
    <div class="is-not-game" v-show="is_not_game">
      <div class="not-game-info">
        <div class="boxss">
          <div class="tlss"></div>
          <div class="tltext">您当前已无游戏次数，点击下方按钮分享， 即可再玩一次！</div>
          <div class="sharebtn">
            <span @click="onShareBtn(2)"></span>
          </div>
          <div class="linkbtn">
            <div><a href="https://mp.weixin.qq.com/s/5HKd-IILrT1Kg1lBkDVXtQ" target="_blank"></a></div>
            <div id="launch-btn">
              <wx-open-launch-weapp
                id="launch-btn"
                username="gh_c5aa58b251c1"
                path="pages/index/index?q=hhxxl-mnq"
                @error="handleErrorFn()"
                @launch="handleLaunchFn()"
              >
                <script type="text/wxtag-template">
                              <style>.btn{ width:246px;
                  height:90px;display:inline-block; opacity:0}</style>
                            <button class="btn">打开小程序</button>
                </script>
              </wx-open-launch-weapp>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 选项事件 -->
    <div class="popevent" v-if="popEventShow">
      <div class="bg"></div>
      <div class="event-box">
        <div class="veginfo">
          <div class="text-tl"></div>
          <!-- <div v-if="is_period_text" class="period-text">{{ opt_period_text }},{{ this.outtime }}</div> -->
          <div v-if="is_period_text" class="period-text">{{ opt_period_text }}</div>
          <div v-else>
            <div class="textb">
              {{ eventInfo.event_text }}
            </div>
            <div
              class="item"
              @click="
                onSelectEvent({
                  text_progress: eventInfo.opt_one_progress,
                  text_year: eventInfo.opt_one_year,
                  text_result: eventInfo.opt_one_result,
                  opt_period_text: eventInfo.opt_one_period_text,
                  opt_text: eventInfo.opt_one_text
                })
              "
            >
              {{ eventInfo.opt_one_text }}
            </div>
            <div
              class="item"
              @click="
                onSelectEvent({
                  text_progress: eventInfo.opt_two_progress,
                  text_year: eventInfo.opt_two_year,
                  text_result: eventInfo.opt_two_result,
                  opt_period_text: eventInfo.opt_two_period_text,
                  opt_text: eventInfo.opt_two_text
                })
              "
            >
              {{ eventInfo.opt_two_text }}
            </div>
            <div
              class="item"
              v-if="eventInfo.opt_three_text"
              @click="
                onSelectEvent({
                  text_progress: eventInfo.opt_three_progress,
                  text_year: eventInfo.opt_three_year,
                  text_result: eventInfo.opt_three_result,
                  opt_period_text: eventInfo.opt_three_period_text,
                  opt_text: eventInfo.opt_three_text
                })
              "
            >
              {{ eventInfo.opt_three_text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新手引导 -->
    <div class="new-guide" v-if="guide_tip" @click="onGuideTipHide()">
      <div class="tip01"></div>
      <div class="tip02"></div>
      <div class="tip03"></div>
    </div>
    <!-- 微信分享提示  -->
    <div class="share-tip-pop" v-if="is_share_tip" @click="onShareTipHide()">
      <span></span>
    </div>
    <!-- <button @click="onClear()" style="position:fixed;z-index:1000; right:6%; top:5%">清除缓存</button> -->
  </div>
  <div v-else class="loading"></div>
</template>
<script>
// api
import { shareReport, wxconfig, initData, eventData, resultData } from './api';
// UI
import { Toast } from 'mint-ui';
import env from '@qtt/env';
import { getQuery, getNonce } from '@/common/utils';
import sg from '@/common/storage';
import log from '@/common/report';
// eslint-disable-next-line no-undef
var wx = require('weixin-js-sdk');
export default {
  components: {},
  data() {
    return {
      mpPath: 'pages/index/index',
      is_start: false, //是否开始
      is_result: false, //是否展示结果
      wxConfigData: {}, //微信分享配置
      initData: {}, // 活动初始化
      tempdata: {}, // post tempdata
      yearnum: 0, //年轮
      yearlist: [],
      progressVal: 1,
      popEventShow: false, //选项事件弹框
      is_period_text: false, //是否有阶段文案
      timer: null, //定时器
      times: null, //定时器
      outtime: 10, // 60s
      opt_period_text: '', //阶段文案
      stagelist: [], //全部阶段文案
      eventInfo: {
        id: 1,
        pub_type: 1, // 1.人物事件/2.公共事件
        relation_name: '',
        form_type: 1, // 1.选项事件/2.文字事件??
        event_text: '',
        opt_one_text: '',
        opt_one_result: 0, // 特殊结局id  0向下，+进度； 非0 +进度 、出结果??
        opt_one_progress: 0, // 进度，百分比
        opt_one_year: 0, // 年份
        opt_two_text: '',
        opt_two_result: 0,
        opt_two_progress: 0, // 百分比 ??100%
        opt_two_year: 0,
        opt_three_text: '',
        opt_three_result: 0,
        opt_three_progress: 0, // 百分比 >100跳结果
        opt_three_year: 0,
        opt_period_text: '' //为空下一个事件 不为空民展示此文字在向下个事件 ??
      }, //
      resultInfo: {}, //结局信息
      is_next: 0,
      share_picture: '', //分享图片
      end_picture: '', //结果图片
      isWeixinBrowser: env.isWeixinBrowser(),
      isAndroid: env.isAndroid(),
      is_share_tip: false,
      guide_tip: false,
      ua: '',
      pagesize: 1,
      autotext: {},
      is_loading: false,
      is_not_game: false,
      timeslAStatus: false,
      timeslBStatus: false,
      miniHeight: false
    };
  },
  watch: {},
  computed: {},
  beforeMount() {
    this.temp_id = sg.getStorage('uuid') || '';
  },
  mounted() {
    //1.初始化数据
    this.tempdata = {
      app_id: 'a4hM7xQHBRHb',
      name: '洪荒西行录-西游模拟器' //活动名称
    };
    this.init();

    //2.上报
    let tempReport = {
      page: 'xymnq',
      event: 'page-show',
      action: 'show',
      extend_info: {
        activity_name: '洪荒西行录-西游模拟器'
      }
    };
    log.report(tempReport);
  },
  beforeDestroy() {},
  methods: {
    onClear() {
      localStorage.clear();
      window.location.reload();
    },
    handleErrorFn(e) {
      console.log('fail', e.detail);
    },
    handleLaunchFn(e) {
      console.log('success', e);
    },
    onShareTipHide() {
      this.is_share_tip = false;
    },
    onGuideTipHide() {
      this.guide_tip = false;
    },
    //微信config
    getWxConfig() {
      this.tempdata.sign_url = `${window.location.origin}${window.location.pathname}`;
      this.tempdata.nonceStr = getNonce(16);
      this.tempdata.timestamep = new Date().getTime();

      wxconfig(this.tempdata)
        .then(res => {
          this.wxConfigData = res.data;
          let configData = {
            // debug: true,
            appId: this.wxConfigData.wx_app_id, // 必填，公众号的唯一标识
            timestamp: this.wxConfigData.timestamp, // 必填，生成签名的时间戳
            nonceStr: this.wxConfigData.nonce_str, // 必填，生成签名的随机串
            signature: this.wxConfigData.sign, // 必填，签名
            jsApiList: [
              'checkJsApi',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'updateTimelineShareData',
              'updateAppMessageShareData',
              'hideShareMenu',
              'showShareMenu',
              'hideOptionMenu',
              'showOptionMenu'
            ],
            openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
          };
          // let _this = this;
          wx.config(configData);
          wx.ready(function() {
            console.log('ready');
            let title = '西游取经模拟器，从未见过如此脑洞';
            let desc = '取经取到外太空，这取经好难啊！';
            let link = location.href;
            let imgUrl = 'https://www.thhdsh.com/ng/prod/hwyy-grow-pic/share-icon.png';
            // onMenuShareAppMessage  updateAppMessageShareData
            wx.checkJsApi({
              jsApiList: [
                'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'updateTimelineShareData',
                'updateAppMessageShareData',
                'hideShareMenu',
                'showShareMenu',
                'hideOptionMenu',
                'showOptionMenu'
              ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function(res) {
                console.log(res, 'checkJsApi');
              }
            });

            wx.hideOptionMenu();
            //wx.hideShareMenu({
            //   menus: ['shareAppMessage', 'shareTimeline']
            // })
            wx.updateAppMessageShareData({
              title, // 分享标题
              desc, // 分享描述
              link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl, // 分享图标
              success: function(res) {
                // 设置成功
                console.log(res, 'share success------1');
                // _this.shareSuccess();
              }
            });

            //分享到朋友圈 onMenuShareTimeline updateTimelineShareData
            wx.updateTimelineShareData({
              title, // 分享标题
              link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl, // 分享图标
              success: function(res) {
                console.log(res, 'share success------2');
                // _this.shareSuccess();
                // 设置成功
              }
            });
          });
          wx.error(function(res) {
            console.log('err', res);
          });
        })
        .catch(error => {
          console.log(error, 'reward');
        })
        .finally(() => {
          // Indicator.close();
        });
    },
    //微信分享成功
    shareSuccess() {
      shareReport(this.tempdata)
        .then(res => {
          this.is_next = res.data.is_next;
          let tempReport = {
            page: 'xymnq',
            event: 'page-share-success',
            action: 'click',
            extend_info: {
              activity_name: '洪荒西行录-西游模拟器'
            }
          };
          log.report(tempReport);
          // this.wxConfigData = res.data;
        })
        .catch(error => {
          console.log(error, 'reward');
        })
        .finally(() => {
          // Indicator.close();
        });
    },
    iosTrouchFn() {
      var el = document.querySelector('.textval'); //你需要滑动的dom元素
      el.addEventListener('touchmove', function(e) {
        e.isSCROLL = true;
      });
      document.body.addEventListener(
        'touchmove',
        function(e) {
          if (!e.isSCROLL) {
            e.preventDefault(); //阻止默认事件(上下滑动)
          } else {
            //需要滑动的区域
            var top = el.scrollTop; //对象最顶端和窗口最顶端之间的距离
            var scrollH = el.scrollHeight; //含滚动内容的元素大小
            var offsetH = el.offsetHeight; //网页可见区域高
            var cScroll = top + offsetH; //当前滚动的距离
            //被滑动到最上方和最下方的时候
            if (top == 0) {
              top = 1; //0～1之间的小数会被当成0
            } else if (cScroll === scrollH) {
              el.scrollTop = top - 0.1;
            }
          }
        },
        { passive: false }
      ); //passive防止阻止默认事件不生效
    },
    onStartBtn() {
      if (!this.isAndroid) {
        document.body.style.overflow = 'hidden';
        if (document.documentElement.clientHeight < 700) {
          this.miniHeight = true;
        }
      }

      this.is_start = true;
      this.guide_tip = true;
      let times = null;
      times = setTimeout(() => {
        this.guide_tip = false;
        // this.iosTrouchFn();
        clearTimeout(times);
      }, 5000);
    },
    //获取活动初始化数据
    init() {
      //0.init data

      initData(this.tempdata)
        .then(res => {
          // console.log(res.data, 'init event');
          this.initData = res.data;
          this.is_loading = true;

          //4s后转场
          this.times = setTimeout(() => {
            clearTimeout(this.times);
            this.onStartBtn();
            //获取事件
            this.getEventList();
          }, 6000);
        })
        .catch(error => {
          this.is_loading = true;
          this.is_not_game = true;
          console.log(error, 'init reward');
        })
        .finally(e => {
          console.log(e);
        });
      //1.wx.config init share
      this.getWxConfig();

      // this.initData = {
      //   round: 3,
      //   role_name: '小灵猴',
      //   icon: '',
      //   picture: '',
      //   show_text: '',
      //   team_mate: ['沙和尚', '紫霞仙子', '嫦娥', '白晶晶', '菩提老祖', '春三十娘']
      // };

      let wxcode = getQuery('code');
      console.log(wxcode);
    },
    // 倒计时
    getCodeAfter(val) {
      this.timer = setInterval(() => {
        this.outtime--;
        if (this.outtime <= 0) {
          // console.log('倒计时', this.outtime);
          clearTimeout(this.timer);
          this.outtime = 10; //60s
          this.getEventList();
          console.log(val, 'get code after ...');

          // if (val.text_result > 0 || val.text_progress > 100) {
          //   //a.选项事出结果
          //   this.storyEnding(val);
          // } else {
          //   //b.继续向下取事件

          // }
        }
      }, 1000);
    },
    stageText(val) {
      const el = document.querySelector('.textval');
      el.scrollTop = el.scrollHeight + 1200;
      this.stagelist.push(val);
    },
    stageText1(val) {
      // this.stagelist.unshift(val);
      this.pagesize++;
      this.autotext = document.querySelector('.textval');
      this.autotext.scrollTop = this.pagesize * 200;
      // let offsetHeight = this.autotext.offsetHeight;

      this.stagelist.push(val);
      if (this.autotext.offsetHeight !== undefined) {
        this.autotext.scrollTop = this.pagesize * 200;
        console.log(1);
      } else {
        this.autotext.scrollTop = this.pagesize * 200;
        console.log(2);
      }

      console.log(this.pagesize, 'this.pagesize', this.autotext.scrollTop, this.autotext.offsetHeight);

      // // const offsetHeight = el.offsetHeight;
      // this.autotext.onscroll = () => {
      //   const scrollTop = this.autotext.scrollTop;
      //   const scrollHeight = this.autotext.scrollHeight;

      //   if (offsetHeight + scrollTop - scrollHeight >= -1) {
      //     console.log('111111');
      //   }
      // };
    },
    //选项事件选取
    onSelectEvent(obj) {
      // console.log(obj, 'onSelectEvent');

      if (obj.text_result > 0 || obj.text_progress > 100) {
        this.storyEnding(obj);
      } else {
        // this.eventInfo.event_text = obj.opt_period_text;
        this.popEventShow = false;
        //选项阶段文案列表
        let temptext = `${this.eventInfo.event_text}， 你选择了“${obj.opt_text}” —— ${obj.opt_period_text}`;
        this.stageText(temptext);
      }

      //2.
      this.onYearVal(obj);
    },
    //获取下一个事件
    nextEvent() {
      // console.log('向下取事件');
      // this.getEventList();
      this.storyEnding(this.eventInfo);
    },
    //获取事件信息
    getEventList() {
      //1. 初始化状态
      this.is_result = false;
      this.is_period_text = false;
      this.eventInfo = {
        event_text: '',
        form_type: null,
        id: 0,
        opt_one_period_text: '',
        opt_one_result: 0,
        opt_one_text: '',

        opt_two_period_text: '',
        opt_two_result: 0,
        opt_two_text: '',

        opt_three_period_text: '',
        opt_three_result: 0,
        opt_three_text: '',

        pub_type: null,
        relation_name: '',
        text_result: 0
      };

      //2. get event
      eventData(this.tempdata)
        .then(res => {
          // console.log(res.data, 'eventData');
          this.eventInfo = res.data;

          //强行出结果；
          if (this.eventInfo.force_result > 0) {
            let obj = {
              text_result: this.eventInfo.force_result,
              text_progress: 0
            };
            this.storyEnding(obj);
            return;
          }
          //1.选项事件  2.文字事件
          if (this.eventInfo.form_type === 1) {
            //选项事件
            this.popEventShow = true;
          } else {
            //文字事件
            //a.关闭弹框
            this.popEventShow = false;
            //文字事件阶段文案列表
            this.stageText(this.eventInfo.event_text);
          }

          //b.显示年轮和进度
          this.onYearVal(this.eventInfo);
        })
        .catch(error => {
          console.log(error, 'reward');
        });

      // let templist = [
      //   {
      //     id: 1,
      //     pub_type: 1, // 1.人物事件/2.公共事件
      //     relation_name: '小香猪',
      //     form_type: 1, // 1.选项事件/2.文字事件??
      //     event_text: '文案文案，高亮，经过x年',
      //     opt_one_text: '选项1文案',
      //     opt_one_result: 0, // 特殊结局id  0向下，+进度； 非0 +进度 、出结果??
      //     opt_one_progress: 22, // 进度，百分比
      //     opt_one_year: 23, // 年份
      //     opt_two_text: '选项2文案',
      //     opt_two_result: 0,
      //     opt_two_progress: 22, // 百分比 ??100%
      //     opt_two_year: 45,
      //     // opt_three_text: '选项3文案',
      //     // opt_three_result: 41,
      //     // opt_three_progress: 22, // 百分比 >100跳结果
      //     // opt_three_year: 23,
      //     opt_period_text:
      //       '唐僧师徒路过万寿山五庄观，借宿观内。观主镇元大仙外出听经，嘱咐童儿以人参果款待唐僧。唐僧见果害怕不敢吃，两童子就吃了。（如果选项的特殊结局id=0）' //为空下一个事件 不为空民展示此文字在向下个事件 ??
      //   },
      //   {
      //     id: 2,
      //     pub_type: 1, // 1.人物事件
      //     relation_name: '小香猪',
      //     form_type: 2, // 1.选项事件/2.文字事件

      //     text_progress: 22, // 百分比
      //     text_year: 12,
      //     text_result: 0 // 结局id
      //   }
      // ];
      // this.eventInfo = templist[0];
    },
    //年轮处理
    onYearVal(val) {
      if (!val.text_year) {
        val.text_year = 0;
        val.text_progress = 0;
      }
      //1.yearVal
      // console.log(this.yearnum, val.text_year, 'yearnum');
      this.yearnum = parseInt(this.yearnum) + parseInt(val.text_year); // 最大不超过 99年
      if (this.yearnum > 100) {
        this.yearnum = 99;
      }
      if (this.yearnum < 10) {
        this.yearnum = '0' + this.yearnum;
      }

      this.yearlist = String(this.yearnum).split('');
      //2.progressVal
      this.progressVal = this.progressVal + val.text_progress;

      // text_progress,
      // text_year
    },
    //故事结局
    storyEnding(val) {
      console.log(val, 'storyEnding');

      let storyResult = () => {
        this.is_result = true;
        this.popEventShow = false;
        resultData(this.tempdata)
          .then(res => {
            if (!this.isAndroid) {
              document.body.style.overflow = 'auto';
            }
            this.resultInfo = res.data;
            this.is_next = res.data.is_next;
            this.end_picture = `https://www.thhdsh.com/ng/prod/hwyy-grow-pic/${this.resultInfo.share_picture}.png`;
            this.share_picture = `https://www.thhdsh.com/ng/prod/hwyy-grow-pic/01/${this.resultInfo.share_picture}.png`;
          })
          .catch(error => {
            console.log(error, 'reward');
          })
          .finally(() => {
            // Indicator.close();
          });
      };

      if (val.text_result > 0) {
        this.tempdata.result_id = val.text_result; //50018;
        storyResult();
        return;
      }

      if (this.progressVal > 100) {
        this.tempdata.result_id = val.text_result || 0; //50018;
        storyResult();
        return;
      }
      this.getEventList();
    },
    storyEnding1(val) {
      this.tempdata.result_id = val.text_result; //50018;
      if (val.text_result > 0 || val.text_progress > 100) {
        this.is_result = true;
        this.popEventShow = false;
        resultData(this.tempdata)
          .then(res => {
            // "id":50008, 结局ID
            // "tp":2, 成功1，失败2
            // "text":"在取得真经后师徒众人开心的返程， 结果路过通天河时候由于没付摆渡钱，被老龟丢全部丢到水里，导致经书全部湿了无法使用，获得竹篮打水一场空成就~",
            // "picture":"",
            // "share_text":"取经取了个寂寞，你也来试试吧！",
            // "share_picture":
            this.resultInfo = res.data;
            this.is_next = res.data.is_next;
            // let envstr = location.href;
            // envstr = envstr.indexOf('pre') > 0 ? 'pre' : 'prod';
            // this.share_picture = `${location.protocol}//${location.hostname}/ng/${envstr}/hwyy-grow/img/${this.resultInfo.share_picture}.png`;
            this.end_picture = `https://www.thhdsh.com/ng/prod/hwyy-grow-pic/${this.resultInfo.share_picture}.png`;
            this.share_picture = `https://www.thhdsh.com/ng/prod/hwyy-grow-pic/01/${this.resultInfo.share_picture}.png`;
          })
          .catch(error => {
            console.log(error, 'reward');
          })
          .finally(() => {
            // Indicator.close();
          });
      } else {
        this.getEventList();
      }
    },
    onShareBtn() {
      this.is_share_tip = true;
      let tempShareText = '';
      if (this.resultInfo.text) {
        tempShareText = this.resultInfo.text.replace(/<.+?>/g, '');
      }
      let title = this.resultInfo.share_text;
      let desc = tempShareText;
      let link = location.href;
      let imgUrl = this.share_picture;

      if (JSON.stringify(this.resultInfo) === '{}') {
        title = '西游取经模拟器，从未见过如此脑洞';
        desc = '取经取到外太空，这取经好难啊！';
        link = location.href;
        imgUrl = 'https://www.thhdsh.com/ng/prod/hwyy-grow-pic/share-icon.png';
        this.initPlaying();
      } else {
        let timesl = null;
        if (!this.timeslAStatus) {
          this.timeslBStatus = true;
          timesl = setTimeout(() => {
            console.log(
              '%cHelloon_ShareBtn',
              'color: #43bb88;font-size: 24px;font-weight: bold;text-decoration: underline;'
            );
            // this.timeslAStatus = false;
            this.playingOnce(1);
            clearTimeout(timesl);
          }, 8000);
        }
      }

      console.log(title, desc);
      wx.showOptionMenu();
      // wx.showShareMenu({
      //   withShareTicket: true,
      //   menus: ['shareAppMessage', 'shareTimeline'],
      //   success(res) {
      //     console.log('showShareMenu', res);
      //   }
      // });

      wx.updateAppMessageShareData({
        title, // 分享标题
        desc, // 分享描述
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: function(res) {
          // 设置成功
          console.log(res, 'share success------1');
        }
      });

      //分享到朋友圈
      wx.updateTimelineShareData({
        title, // 分享标题
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: function(res) {
          // 设置成功
          // _this.shareSuccess();
          console.log(res, 'share success------2');
        }
      });

      this.shareSuccess();
      let tempReport = {
        page: 'xymnq',
        event: 'share-btn',
        action: 'click',
        extend_info: {
          activity_name: '洪荒西行录-西游模拟器'
        }
      };
      log.report(tempReport);
    },
    initPlaying() {
      let timesl = null;
      console.log(this.timeslBStatus);
      if (!this.timeslBStatus) {
        this.timeslBStatus = true;
        timesl = setTimeout(() => {
          console.log(
            '%cHello_initPlaying',
            'color: #43bb88;font-size: 24px;font-weight: bold;text-decoration: underline;'
          );
          // this.timeslBStatus = true;
          this.is_not_game = false;
          this.init();
          this.onShareTipHide();
          clearTimeout(timesl);
        }, 8000);
      }
    },
    playingOnce(val) {
      //event_text
      console.log(this.resultInfo.is_next, this.is_next, 'playingOnce');
      if (this.is_next > 0) {
        window.location.reload();
      } else {
        if (val !== 1) {
          Toast('转发给好友，可获得一次机会');
        }
      }

      let tempReport = {
        page: 'xymnq',
        event: 'playing-once-btn',
        action: 'click',
        extend_info: {
          activity_name: '洪荒西行录-西游模拟器'
        }
      };
      log.report(tempReport);
    },
    //下载APK
    onDowload() {
      // let dowurl = this.isAndroid ? this.activity.download.android : this.activity.download.ios;
      // if (this.isWeixinBrowser) {
      //   this.iswxtip = true;
      //   return;
      // }
      // // console.log(this.isAndroid, this.isWeixinBrowser, 'location.href:' + dowurl);
      // let tempReport = {
      //   page: 'dowload',
      //   event: `dowload-app-btn-${this.system}`,
      //   action: 'click',
      //   extend_info: {
      //     system: `${this.system}`
      //   }
      // };
      // log.report(tempReport);
      // window.location.href = dowurl;
    }
  }
};
</script>
